import React from "react";
import { CustomComponentCustomFormField } from "../../../../../amorg-common";
import { RadioButton } from "../../../../../designSystem/inputs/RadioButton";
import { RadioGridHeader, PostHeader, PreHeader, RadioContainer, OptionHeader, RadioRow } from "../RadioButtonColumnCustomFormFieldComponent";
import { AnswerFieldContext } from "../../customFormFieldFactory";
import { CustomFormFieldHeader } from "../../../[parm]/_components/CustomFormFieldHeader";

import { CustomFormFieldFooter } from "../../../[parm]/_components/CustomFormFieldFooter";
import { CustomFormFieldCard } from "../../../[parm]/_components/CustomFormFieldCard";

type TimePointsCustomFormFieldComponentProps = AnswerFieldContext & {
    field:CustomComponentCustomFormField
}
// eslint-disable-next-line @typescript-eslint/no-unused-vars
export function TimePointsCustomFormFieldComponent(props:TimePointsCustomFormFieldComponentProps):JSX.Element
{
    let validTypeSelected = false;
    const timePointTypeSelection = props.answer.selections.find(s => s.fieldId === 'timePointType');
    if(timePointTypeSelection)
    {
        const expectedValues = ['løfte', 'holde', 'bære', 'short_distance', 'long_distance'];
        validTypeSelected = expectedValues.includes(timePointTypeSelection.value);
    }

    if(!validTypeSelected)
        return <div>Vælg værdi for bestemmelse af tidspoint</div>;

    let config:{preHeader:string, postHeader:string, text:string, footer:string, options:{value:string, preHtml: string, postHtml:string }[]} = 
    {
        preHeader:'Løfte eller flytte emner ( under 5 sek ) antal gange pr. arbejdsdag', 
        postHeader: 'Tidspunkt',
        text: `
            Eksempler
            <ul>
            <li>At mure</li>
            <li>At placere arbejdsemner i en maskine</li>
            <li>At tømme en container for kasser og placere dem på et transportbånd</li>
            </ul>
        `,
        footer:``,
        options:[
            { 
                value:'1', 
                preHtml:'Under 10',
                postHtml:'1' 
            },
            { 
                value:'2', 
                preHtml:'10 < 40',
                postHtml:'2' 
            },
            { 
                value:'4', 
                preHtml:'40 < 200',
                postHtml:'4'
            },
            { 
                value:'6', 
                preHtml:'200 < 500',
                postHtml:'6'
            },
            { 
                value:'8', 
                preHtml:'500 < 1000',
                postHtml:'8'
            },
            { 
                value:'10', 
                preHtml:'Mere end 1000',
                postHtml:'10'
            },
        ]
    };

    if(timePointTypeSelection.value === 'holde')
    {
        config = 
        {
            preHeader:'Holde emner ( over 5 sek ) samlet tid i løbet af arbejdsdagen', 
            postHeader: 'Tidspunkt',
            text: `
                Eksempler
                <ul>
                <li>At holde eller styre et stykke jern ved arbejde med en slibemaskine</li>
                <li>Brug af en håndslibemaskine</li>
                <li>Brug af en ukrudtsbrænder</li>
                </ul>
            `,
            footer:``,
            options:[
                { 
                    value:'1', 
                    preHtml:'Under 5 min',
                    postHtml:'1'
                },
                { 
                    value:'2', 
                    preHtml:'5 < 15 min',
                    postHtml:'2' 
                },
                { 
                    value:'4', 
                    preHtml:'15 min < 1 t',
                    postHtml:'4'
                },
                { 
                    value:'6', 
                    preHtml:'1 t < 2 t',
                    postHtml:'6'    
                },
                { 
                    value:'8', 
                    preHtml:'2 t < 4 t',
                    postHtml:'8'
                 },
                { 
                    value:'10', 
                    preHtml:'Mere end 4 t',
                    postHtml:'10'
                },
            ]
        };
    }
    
    if(timePointTypeSelection.value === 'bære')
        {
            config = 
            {
                preHeader:'Bære emner ( over 2 m ) samlet afstand i løbet af arbejdsdagen', 
                postHeader: 'Tidspunkt',
                text: `
                Eksempler
                <ul>
                <li>At mure</li>
                <li>At placere arbejdsemner i en maskine</li>
                <li>At tømme en container for kasser og placere dem på et transportbånd</li>
                </ul>
                `,
                footer:``,
                options:[
                    { 
                        value:'1', 
                        preHtml:'Under 300 m',
                        postHtml:'1'
                    },
                    { 
                        value:'2', 
                        preHtml:'300 m < 1 km',
                        postHtml:'2'},
                    { 
                        value:'4', 
                        preHtml:'1 km < 4 km',
                        postHtml:'4'
                    },
                    { 
                        value:'6', 
                        preHtml:'4 km < 8 km',
                        postHtml:'6'
                    },
                    { 
                        value:'8', 
                        preHtml:'8 km < 16 km',
                        postHtml:'8'
                    },
                    { 
                        value:'10', 
                        preHtml:'Mere end 16 km',
                        postHtml:'10'
                    },
                ]
            };
        }

    if(timePointTypeSelection.value === 'short_distance')
        {
            config = 
            {
                preHeader:`Træk og skub korte afstande eller mange stop - (enkelt afstande over 5 meter)`, 
                postHeader: 'Tidspoint',
                text: ``,
                footer:`<b>Eksempler</b> <br/>Brug af manipulatorer, opsætning af maskiner, distribution af
måltider på hospitaler.`,
                options:[
                    { 
                        value:'1', 
                        preHtml:'Under 10 m',
                        postHtml:'1'
                    },
                    { 
                        value:'2', 
                        preHtml:'10 m < 40 m',
                        postHtml:'2'},
                    { 
                        value:'4', 
                        preHtml:'40 m < 200 m',
                        postHtml:'4'
                    },
                    { 
                        value:'6', 
                        preHtml:'200 m < 500 m',
                        postHtml:'6'
                    },
                    { 
                        value:'8', 
                        preHtml:'500 m < 1000 m',
                        postHtml:'8'
                    },
                    { 
                        value:'10', 
                        preHtml:'Over 1000 m',
                        postHtml:'10'
                    },
                ]
            };
        }

    if(timePointTypeSelection.value === 'long_distance')
        {
            config = 
            {
                preHeader:'Træk og skub længere afstande - (enkelt afstande under 5 meter)', 
                postHeader: 'Tidspoint',
                text: ``,
                footer:`<b>Eksempler</b> <br/>Affaldsindsamling, møbeltransport indendørs med hjul,
aflæsning og omlæsning af containere`,
                options:[
                    { 
                        value:'1', 
                        preHtml:'Under 300 m',
                        postHtml:'1'
                    },
                    { 
                        value:'2', 
                        preHtml:'300 m < 1 km',
                        postHtml:'2'},
                    { 
                        value:'4', 
                        preHtml:'1 km < 4 km',
                        postHtml:'4'
                    },
                    { 
                        value:'6', 
                        preHtml:'4 km < 8 km',
                        postHtml:'6'
                    },
                    { 
                        value:'8', 
                        preHtml:'8 km < 16 km',
                        postHtml:'8'
                    },
                    { 
                        value:'10', 
                        preHtml:'Over 16 km',
                        postHtml:'10'
                    },
                ]
            };
        }

    async function handleChange(value:string)
    {
        await props.onSubmit([{ fieldId: props.field.fieldId, value }]);
        props.doUpdate();
    }

    return (
        <section>
            <CustomFormFieldHeader field={props.field} />
            <CustomFormFieldCard>

                <RadioGridHeader>
                    <PreHeader>{config.preHeader}</PreHeader>
                    <PostHeader>{config.postHeader}</PostHeader>
                </RadioGridHeader>       

                {config.options.map((option, index) => (

                    <label htmlFor={props.field.fieldId + "_" + index } key={index}>
                        
                        <RadioRow row={3}>
                            
                            <OptionHeader dangerouslySetInnerHTML={{ __html: option.preHtml || '' }} />

                            <RadioContainer>
                                <RadioButton
                                    disabled={props.disabled}
                                    name={props.field.fieldId + '_' + (props.inPrint ? '_print' : '')}
                                    id={props.field.fieldId + "_" + index }
                                    onChange={handleChange}
                                    value={option.value}
                                    text={option.postHtml}
                                    checked={props.answer.selections.find(s => s.fieldId === props.field.fieldId)?.value === option.value}
                                />
                            </RadioContainer>
                        </RadioRow>
                        
                    </label>
                ))}

            </CustomFormFieldCard>
            {config.footer &&
                <CustomFormFieldFooter text={config.footer} />
            }
        </section>
    );
}
